import { render, staticRenderFns } from "./DossierDownloadDialog.vue?vue&type=template&id=790ddfce&scoped=true"
import script from "./DossierDownloadDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./DossierDownloadDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DossierDownloadDialog.vue?vue&type=style&index=0&id=790ddfce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ddfce",
  null
  
)

export default component.exports